import { ActionTree } from "vuex";
import API from "@/axios";
import {
  NationalIdState,
  NationalIdType,
  NewNationalIdPayload,
} from "../types";

const actions: ActionTree<NationalIdState, any> = {
  setNationalIdType({ commit }, nationalIdType: NationalIdType) {
    commit("setNationalIdType", nationalIdType);
    return nationalIdType;
  },
  uploadNewNationalId({ commit }, payload: NewNationalIdPayload) {
    return API.post("/iddocumentdata/upload/", payload, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
  },
  setNationalIdFrontBlob({ commit }, nationalIdFrontBlob: Blob) {
    commit("setNationalIdFrontBlob", nationalIdFrontBlob);
  },
  setNationalIdBackBlob({ commit }, nationalIdBackBlob: Blob) {
    commit("setNationalIdBackBlob", nationalIdBackBlob);
  },
};

export default actions;
